

let brifContacts = document.querySelector(".brif-contacts")
// if(brifContacts) {
//     var brifContactsScroll = ScrollTrigger.create({
//         trigger: "body",
//         start: $('.brif-contacts').offset().top + "px top",
//         scrub: 0.5,
//         onUpdate: function (self) {
//             if (self.isActive) {
//                 $('.brif-contacts').addClass('brif-contacts__fixed');
//                 if (self.direction == '-1') {
//                     if (self.progress == 0) {
//                         $('.brif-contacts').removeClass('brif-contacts__active');
//                     } 
//                 } 
//             } else {
//                 $('.brif-contacts').removeClass('brif-contacts__fixed brif-contacts__active');
//             }
//         }
//     });
//     const wrapperBlock = document.querySelector(".wrapper");

// if (wrapperBlock) {
//     const resizeObserver = new ResizeObserver((entries) => {
//         for (let _ of entries) {
//             brifContactsScroll.refresh();
//         }
//     });

//     resizeObserver.observe(wrapperBlock);
// }
// }
function updateScrollTrigger() {
    if (window.innerWidth > 1650) {
      const brifContacts = document.querySelector('.brif-contacts');
      
      gsap.to(brifContacts, {
        y: 520, // Смещение блока на 520px от верхней части экрана
        duration: 0, // Длительность анимации
        ease: 'none', // Отключение анимации easing (по умолчанию)
        scrollTrigger: {
          trigger: brifContacts, // Триггер для начала анимации (ваш блок)
          start: 'top 120px', // Начните анимацию, когда верхний край блока будет находиться у верха экрана
          end: '+=100%',
          pin: true, // Закрепите блок в фиксированной позиции
          pinSpacing: true, // Отключите автоматическое расстояние между закрепленными элементами
        },
      });
    } else {
      // Удалите ScrollTrigger, если ширина окна меньше 1650px
      gsap.set(brifContacts, { y: 0 });
      ScrollTrigger.getAll().forEach(trigger => {
        trigger.kill();
      });
    }
  }
  
  // Вызовите функцию при загрузке страницы и при изменении размера окна
  window.addEventListener('load', updateScrollTrigger);
  window.addEventListener('resize', updateScrollTrigger);

// Обработка события клик на чек-бокс

let politicCheckbox = document.querySelector('.custom-checkbox')
if(politicCheckbox) {
    politicCheckbox.addEventListener('click', function(event) {
        var buttonElement = event.currentTarget.closest('.brif-form__bottom').querySelector('.btn');
        
        if(buttonElement.hasAttribute("disabled", "disabled")) {
            buttonElement.removeAttribute("disabled", "disabled")
        } else {
            buttonElement.setAttribute("disabled", "disabled")
        }
    })
    document.querySelector('.custom-checkbox input').addEventListener('click', function(event) {
        event.stopPropagation()
    })
}

// Конец Динамическая высота textarea
$(function () {
    $('.brif-form__input-file input').on('change', function (e) {
        $('.input-file .message').html('')
        var files = Array.from(this.files)
        for (var i = 0; i < files.length; i++) {
            previewFileV2(files[i])
        }
    })

    function previewFileV2 (file) {
        var expansion = file.name.slice(file.name.lastIndexOf('.') + 1)
        if (
            expansion === 'docx' ||
            expansion === 'doc' ||
            expansion === 'pdf' ||
            expansion === 'txt' ||
            expansion === 'jpg'
        ) {
            if (file.size <= 2097152) {
                var fileSize = file.size / 1048576
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onloadend = function () {
                    var $fileV2 = $('<div class="file-v2"><p></p></div>')
                    $fileV2.find('p').text(file.name)
                    $('.brif-form__input-file .b-file-name').append($fileV2)
                }
            } else {
                var errorMessage =
                    '<p>Файл ' + file.name + ' превышает 2 Мб</p>'
                displayErrorMessage(errorMessage)
            }
        } else {
            var errorMessage =
                '<p>Формат файла ' + file.name + ' не поддерживается</p>'
            displayErrorMessage(errorMessage)
        }
    }

    function displayErrorMessage (errorMessage) {
        var $errorInfo = $('.brif-form__input-file .info')
        $errorInfo.html(errorMessage).fadeIn()
    }

    // $('.brif-form__input-file .file-v2 a').on('click', function (e) {
    //     e.preventDefault()
    //     $(this).closest('.file-v2').remove()
    //     if ($('.brif-form__input-file .file-v2').length === 0) {
    //         $('.brif-form__input-file .info').fadeOut()
    //     }
    //     $('.brif-form__input-file input').val('')
    // })

    $('.brif-form__btn').on('click', function (e) {
        $('.brif-form__body').submit();
    });

    $('.brif-form__body').on('submit', function (e) {
        //- Остановка отправки формы https://learn.javascript.ru/forms-submit
        e.preventDefault();
        //- Переменная для отправки формы
        var $this = $(this);

        //- Валидация ------------------------------

        $('.brif-form__row.require input, .brif-form__row.require textarea').each(function (i,it) {
           let input = $(it);
           let inputPar = input.parent();

            if (input.val().length !== 0) {
                //- Проверка выполнена успешно (поле заполнено)
                inputPar.removeClass('wrong');
            } else {
                //- Проверка неудачна (поле пустое)
                inputPar.addClass('wrong');
            }
        });


        //- Проверка на соответсвие всех полей необходимым проверкам
        if ($this.find('.wrong').length == 0) {
            //- Конец валидации ----------------------------------------------

            $this.trigger('precapcha');
        }

    });
    $('.brif-form__body').on('postcapcha', function (e) {
        var $this = $(this);
        //console.log('submit');
        feedbackThanksV2.openModal();
        //feedbackModal.closeModal();


        var fd = new FormData(this);
        //- Выполнить ajax отправку данных на сервер
        $.ajax({
            url: $this.attr('action'), // Файл в который отправить данные
            type: $this.attr('method'), // Метод отправки данных
            data: fd, // Получить все данные формы  https://ruseller.com/jquery?id=8
            processData: false,
            contentType: false,
            success: function () { // Функция выполняемая в случае успешной отправки формы
                //- Очистить форму после отправки
                $this[0].reset();
                console.debug('brif sended');
                feedbackThanksV2.openModal();
                //feedbackModal.closeModal();
                setTimeout(()=>{window.location.href = '/';}, 500);
            }
        });
        $this.trigger('afterrequest');
    });


    // Ответ по форме

    var feedbackThanksV2 = new SmModal({
        modalSelector: '#tahnksmodV2',
        backgroundBlur: true,
        backgroundBlurValue: '10px',
        overlay: 'background-color: rgba(36, 43, 47, 0.75)',
        afterOpen: function () {
            // blockArrowAnimate();
            // arrowSizeOpen();
            $('#tahnksmodV2 .thanks-mod__arrow-wp').addClass('thanks-mod__arrow-wp_active');
        },
        afterClose: function () {
            $('#tahnksmodV2 .thanks-mod__arrow-wp').removeClass('thanks-mod__arrow-wp_active');
            // $('.feedback__arr .block-arrow').height(0).width(0);
            // $('.feedback__arr .block-arrow span').removeClass('active');
        },
    });
})
